import React from 'react'
import ReactDatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import './LocalizedDatePicker.css'
import { useTranslation } from '../../context/LanguageContext'
import { getDatePickerDateFormat } from '../../config/DatePickerLocale'

const LocalizedDatePicker = ({ dateFormat, locale, ...props }) => {
    const { locale: lang } = useTranslation()

    return (
        <ReactDatePicker
            key={locale || lang}
            locale={locale || lang}
            dateFormat={dateFormat || getDatePickerDateFormat(lang)}
            {...props}
        />
    )
}

export default LocalizedDatePicker
